import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
const LIST_AUTOMATIONS_PATH = '/rest/automations';
export function getListAutomationsQueryKeyPrefix() {
    return QueryClientHelper.makeQueryKey(LIST_AUTOMATIONS_PATH);
}
//# sourceMappingURL=useListAutomations.js.map